import { render } from "./Home.vue?vue&type=template&id=25e1c8b3&lang=pug"
import script from "./Home.vue?vue&type=script&lang=ts"
export * from "./Home.vue?vue&type=script&lang=ts"
script.render = render

export default script